import { FormKitNode } from '@formkit/core';
import { useI18n } from 'vue-i18n';

import { Onboarding } from '@/services/requests/onboarding/Onboarding.types';
import { extractFormkitRules } from '@/utils/extractFormkitRule';

export function maxLengthHelpFromPattern(node: FormKitNode) {
  const types = ['TextPatternTextArea', 'textarea'];

  if (!types.includes(node.context?.type ?? '')) return;
  const pattern = node.context?.pattern as Onboarding.Business.CompanyDetailsPattern;

  const { t } = useI18n();

  node.on('created', () => {
    const rules = extractFormkitRules(node?.props?.validation);
    const ruleMaxLength = rules?.length && Array.isArray(rules?.length)
      ? rules.length.at(1)
      : undefined;

    if (node.context === undefined || (pattern?.maxlength === undefined && ruleMaxLength === undefined)) return;

    node.context.help ??= t('form.helper.max_length', [pattern?.maxlength ?? ruleMaxLength]);
  });
}
